import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { AUDIT_TOKENS } from "../../theme/auditTokens";
import { SurfaceCard } from "../common/SurfaceCard";
import { REASON_TAX_CLASSES } from "@/constants/ReasonTaxClasses";

/** Legend card in the map's top right corner; the colors are also spelled out as text. */
export function MapLegend() {
  const { t } = useTranslation();
  return (
    <SurfaceCard
      as="ul"
      aria-label={t("logbookAudit.map.legend")}
      sx={{ position: "absolute", top: 10, right: 10, zIndex: 1000, m: 0, p: "8px 12px", listStyle: "none", fontSize: 12.5, boxShadow: AUDIT_TOKENS.shadow.panel }}
    >
      {REASON_TAX_CLASSES.map(taxClass => (
        <Box component="li" key={taxClass} sx={{ display: "flex", alignItems: "center", gap: 1, py: "2px" }}>
          <Box component="span" aria-hidden sx={{ width: 18, height: 4, borderRadius: 2, bgcolor: AUDIT_TOKENS.map[taxClass] }} />
          {t(`logbookAudit.taxClass.${taxClass}`)}
        </Box>
      ))}
    </SurfaceCard>
  );
}
